export const delimiter = "$@$";